<svelte:head>

    <title>Guests • keyosh</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Guests from "../components/guests.svelte";

</script>

<SessionManager />

<section>

    <Guests/>

</section>


<style>

    section {
        height: inherit;
    }

</style>
